import { render, staticRenderFns } from "./CustomToggle.vue?vue&type=template&id=b169c8c8&"
import script from "./CustomToggle.vue?vue&type=script&lang=ts&"
export * from "./CustomToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports